<template>
  <transition name="fade">
    <div class="toast-back">
      <div class="toast">{{ message }}</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ToastComp",
  props: {
    show: Boolean,
    message: String,
  },
  data() {
    return {
      duration: 2000,
    };
  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.close();
        }
      },
      immediate: true,
    },
  },
  beforeUnmount() {
    this.timer && clearTimeout(this.timer);
  },
  methods: {
    close() {
      this.timer = setTimeout(() => {
        this.$emit("update:show", false);
      }, this.duration);
    },
  },
};
</script>

<style lang="less" scoped>
.toast-back {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  .toast {
    font-size: 16px;
    padding: 8px 10px;
    background-color: rgba(17, 17, 17, 0.7);
    border-radius: 12px;
    color: #fff;
  }
}
</style>
